import { Node, mergeAttributes } from "@tiptap/core"
import { ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react"
import type { NodeViewProps } from "@tiptap/react"

function CitationComponent({ node }: NodeViewProps) {
  const codes = node.attrs.codes as string

  return (
    <NodeViewWrapper as="span" className="inline">
      <span
        className="inline-flex items-center gap-1.5 bg-amber-50 border border-amber-200 text-amber-900 px-2.5 py-1 rounded-md text-sm align-middle"
        contentEditable={false}
      >
        <span className="bg-amber-600 text-white text-xs font-semibold px-1.5 py-0.5 rounded">
          REF
        </span>
        <span className="font-medium">{codes}</span>
      </span>
    </NodeViewWrapper>
  )
}

export const CitationExtension = Node.create({
  name: "citation",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      codes: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-codes") || element.textContent?.replace(/^\[|\]$/g, "") || "",
        renderHTML: (attributes) => ({
          "data-codes": attributes.codes,
        }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: "span[data-citation]",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const codes = HTMLAttributes["data-codes"] || ""
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        class: "compliance-citation",
        "data-citation": "",
        "data-codes": codes,
      }),
      `[${codes}]`,
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(CitationComponent)
  },
})
